import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IApiResponse } from '@core/interfaces/api-response.interface';
import { IStats } from '@shared/interfaces/stats.interface';
import { Observable } from 'rxjs';
import { ICreator, ICreatorUpdate, ICreatorWithChannelCreate, TCreatorApi } from './creators.interface';

@Injectable({
  providedIn: 'root',
})
export class CreatorsService {
  constructor(private readonly http: HttpClient) {}

  public getCreators(params?: HttpParams): Observable<IApiResponse<TCreatorApi[]>> {
    return this.http.get<IApiResponse<TCreatorApi[]>>('creators', { params });
  }

  public getAdminCreator(id: string, params?: HttpParams): Observable<ICreator | undefined> {
    return this.http.get<ICreator>(`creators/admin/${id}`, { params });
  }

  public getAdminCreators(params?: HttpParams): Observable<IApiResponse<ICreator[]>> {
    return this.http.get<IApiResponse<ICreator[]>>(`creators/admin`, { params });
  }

  public getCurrentCreator(params?: HttpParams): Observable<ICreator | undefined> {
    return this.http.get<ICreator>(`creators/current`, { params });
  }

  public getCreator(id: string, params?: HttpParams): Observable<ICreator | undefined> {
    return this.http.get<ICreator>(`creators/${id}`, { params });
  }

  public deleteCreator(id: string): Observable<void> {
    return this.http.delete<void>(`creators/${id}`);
  }

  public createCreator(creator: ICreatorWithChannelCreate): Observable<ICreator> {
    return this.http.post<ICreator>('creators', creator);
  }

  public updateCreator(id: string, creator: ICreatorUpdate): Observable<ICreator> {
    return this.http.put<ICreator>(`creators/${id}`, creator);
  }

  public getCreatorsStats(): Observable<IStats[]> {
    return this.http.get<IStats[]>('creators/stats');
  }
}
